// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable formatjs/no-literal-string-in-jsx */
import { Button, Dialog, Stack, Typography, useTheme } from "@carrotfertility/carotene-core"
import React from "react"
import { useHistory, useLocation } from "react-router-dom"

export type IntakeSubmittedLocationState = { intakeQuestionnaireSubmitted?: boolean }

export function IntakeSubmittedDialog(): JSX.Element {
  const theme = useTheme()
  const history = useHistory()
  const location = useLocation<IntakeSubmittedLocationState | undefined>()
  const [open, setOpen] = React.useState(Boolean(location.state?.intakeQuestionnaireSubmitted))

  const close = (): void => {
    setOpen(false)
    // Clear the flag so a refresh won't reshow the dialog.
    history.replace({ pathname: location.pathname, search: location.search, state: undefined })
  }

  return (
    <Dialog open={open} onClose={close} aria-labelledby="intake-submitted-title">
      <Stack spacing={theme.tokens.spacing.md}>
        <Typography variant="h2" id="intake-submitted-title">
          You&apos;re all set.
        </Typography>
        <Typography variant="body1">
          Thanks for sharing this information. Your clinician will review everything before the appointment.
        </Typography>
        <Button variant="contained" color="secondary" onClick={close} sx={{ alignSelf: "flex-end" }}>
          Close
        </Button>
      </Stack>
    </Dialog>
  )
}
